{
  "overview": "Обзор",
  "dashboard": "Дашборды",
  "menuError": {
    "title": "Навигация недоступна",
    "description": "Не удалось загрузить правила навигации. Обновите страницу или попробуйте позже."
  },
  "console": {
    "title": "Консоль",
    "terminal-logs": "Логи терминала",
    "connection": "Подключение"
  },
  "summary": "Сводка",
  "srm": "СРМ",
  "subscriptions": {
    "title": "Уведомления",
    "my-subscriptions": "Мои подписки",
    "external-services": "Внешние сервисы",
    "message-templates": "Шаблоны сообщений",
    "receivers": "Адресаты",
    "userReceivers": "Адресаты пользователей"
  },
  "changeRequest": "Запросы на изменение",
  "access": {
    "title": "Доступ",
    "srm": "СРМ",
    "healthIndicators": "Индикаторы здоровья",
    "navigation": "Функции",
    "dashboards": "Дашборды",
    "tql": "TQL"
  },
  "users": {
    "title": "Пользователи",
    "usersSessions": "Пользовательские сессии",
    "usersRegistry": "Реестр пользователей",
    "usersAuditLogs": "Журналы аудита"
  },
  "attacks": "Атаки",
  "main": "Главная",
  "settings": {
    "title": "Настройки",
    "srm": "СРМ",
    "cit": "Типы КЕ",
    "enrichment": "Планы обогащения",
    "enrichment-statistics": "Итоги обогащения",
    "enrichment-logs": "Процессы обогащения",
    "actionPlans": "Планы действий",
    "attributes": "Атрибуты",
    "monitoring": "Мониторинг",
    "healthIndicators": "Индикаторы здоровья",
    "monitoringSettings": "Задания и Экспортеры",
    "content-pack": "Пакет конфигураций",
    "prometheus": {
      "title": "Prometheus",
      "config": "Конфигурация",
      "alerts": "Тревоги",
      "targets": "Цели",
      "exporters": "Экспортеры"
    },
    "users": "Пользователь",
    "user": "Атрибуты",
    "ldap": "LDAP",
    "oidc": "OIDC",
    "system": "Система",
    "globalSettings": "Глобальные настройки",
    "schedules": "Периодические задания",
    "monitoringTemplates": "Шаблоны мониторинга",
    "vmAgents": "Агенты сбора метрик",
    "vmAlerts": "Агенты обработки правил",
    "s3": "S3-коннекторы",
    "components": "Компоненты",
    "plugins": "Управление плагинами",
    "notifications": {
      "title": "Уведомления",
      "time-interval": "Интервалы времени",
      "senders": "Отправители",
      "receivers": "Адресаты",
      "subscriptions": "Подписки"
    },
    "alertManager": "Alert Manager",
    "inhibitRules": "Правила подавления",
    "notificationsGeneral": "Общие настройки",
    "templates": "Шаблоны сообщений",
    "license": "Лицензия",
    "ci-bulk-import": "Импорт КЕ"
  },
  "breadcrumb": {
    "main": "Главная",
    "subscriptions": {
      "title": "Уведомления",
      "my-subscriptions": "Мои подписки",
      "external-services": "Внешние сервисы",
      "message-templates": "Шаблоны сообщений",
      "receivers": "Адресаты"
    },
    "settings": {
      "name": "Настройки",
      "srm": "СРМ",
      "cit": "Типы КЕ",
      "enrichment": "Планы обогащения",
      "actionPlans": "Планы действий",
      "attributes": "Атрибуты",
      "monitoring": "Мониторинг",
      "healthIndicators": "Индикаторы здоровья",
      "monitoringSettings": "Задания и Экспортеры",
      "prometheus": {
        "title": "Prometheus",
        "config": "Конфигурация Prometheus",
        "alerts": "Тревоги Prometheus",
        "targets": "Цели Prometheus",
        "exporters": "Экспортеры Prometheus"
      },
      "users": "Пользователь",
      "user": "Атрибуты",
      "ldap": "LDAP",
      "system": "Система",
      "plugins": "Управление плагинами",
      "globalSettings": "Глобальные настройки",
      "schedules": "Периодические задания",
      "license": "Лицензия",
      "ci-bulk-import": "Импорт КЕ"
    },
    "srm": {
      "name": "Сервисно-ресурсная модель"
    },
    "changeRequest": {
      "name": "Запросы на изменение"
    },
    "access": {
      "name": "Доступ",
      "healthIndicators": "Индикаторы здоровья",
      "SRM": "СРМ",
      "navigation": "Функции",
      "dashboards": "Дашборды",
      "dashboardsV4": "Дашборды (ACL)",
      "tql": "TQL"
    },
    "users": {
      "list": "Пользователи",
      "profile": "Профиль",
      "usersSessions": "Пользовательские сессии",
      "usersRegistry": "Реестр пользователей"
    },
    "attacks": {
      "name": "Атаки"
    },
    "devices": {
      "name": "Устройства"
    },
    "notification": {
      "name": "Уведомление"
    }
  }
}
